export default "__VITE_ASSET__c97e7ca4__"